import { useSyncExternalStore } from 'react'

const MOBILE_BREAKPOINT = 768
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

// Cache MQL instance at module level
let mql: MediaQueryList | null = null
const getMql = () => {
  if (!mql && typeof window !== 'undefined') {
    mql = window.matchMedia(QUERY)
  }
  return mql
}

const subscribe = (callback: () => void) => {
  const m = getMql()
  if (!m) return () => {}
  m.addEventListener('change', callback)
  return () => m.removeEventListener('change', callback)
}

const getSnapshot = () => getMql()?.matches ?? false

const getServerSnapshot = () => false

export const useIsMobile = () =>
  useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
